import { Injectable } from '@angular/core';
import { Paginated, UserFromSearchDto } from 'app/types';
import { TrinityService } from 'app/services/trinity/trinity.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PeopleService {
  private readonly endpoint: string = '/person';

  constructor(private trinity: TrinityService) {}

  list(
    name_or_email_contains?: string,
  ): Observable<Paginated<UserFromSearchDto>> {
    return this.trinity.get<Paginated<UserFromSearchDto>>(this.endpoint, {
      authorized: true,
      ...(name_or_email_contains && { params: { name_or_email_contains } }),
    });
  }
}
